import { render, staticRenderFns } from "./ApproveRawMaterialPopUp.vue?vue&type=template&id=996de388&scoped=true&"
import script from "./ApproveRawMaterialPopUp.vue?vue&type=script&lang=js&"
export * from "./ApproveRawMaterialPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ApproveRawMaterialPopUp.vue?vue&type=style&index=0&id=996de388&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996de388",
  null
  
)

export default component.exports